import Guid from "@/app/utils/guid"
import NodeEvent from './node-event'
import Node from '@/diagrams/models/node'
import Project from '@/projects/entities/project'

export default class CreateNodeEvent extends NodeEvent {

  public parent: Node
  public className: NodeClassName

  constructor(project: Project, parent: Node, className: NodeClassName) {
    super(project)
    this.parent = parent
    this.className = className
  }
}
